// Toggle customer type radio buttons checked property only (no is-active class)
document.addEventListener('DOMContentLoaded', function () {
    const radioInputs = document.querySelectorAll('.js-type-switch');
    radioInputs.forEach((input) => {
        input.addEventListener('change', () => {
            if (input.checked) {
                radioInputs.forEach((el) => {
                    if (el !== input) {
                        el.checked = false;
                    }
                });
            }

            const companyGroup = document.querySelector('.company-group');
            const isCompanyChecked = document.querySelector('.js-is-company')?.checked;

            if (companyGroup) {
                companyGroup.style.display = isCompanyChecked ? 'block' : 'none';
            }
        });
    });

    // Apply company-group visibility on initial load
    const companyGroup = document.querySelector('.company-group');
    const isCompanyChecked = document.querySelector('.js-is-company')?.checked;
    if (companyGroup) {
        companyGroup.style.display = isCompanyChecked ? 'block' : 'none';
    }
});